import React from 'react';

import { Route, Routes } from 'react-router-dom';

import ProtectedRoute from '../components/protectedRoutes';
import AtualizarRelatorioInvestidor from '../pages/ri/atualizarRelatorioInvestidor';
import FechamentoConsorcio from '../pages/gestaoEnergia/fechamentoConsorcio';
import DreProjetos from '../pages/ri/dreProjetos';

const RouteRI = () => {
    return (
        <Routes>
            <Route element={<ProtectedRoute role='RI'/>}>
                <Route path='atualizarRelatorioInvestidor' element={<AtualizarRelatorioInvestidor/>}/>
                <Route path='dreProjetos' element={<DreProjetos/>}/>
                <Route path='fechamentoConsorcio' element={<FechamentoConsorcio/>}/>
            </Route>
        </Routes>
    );
};

export default RouteRI;
